<template>
  <div class="articlebox">
    <div class="create-box">
        <el-scrollbar>
            <div class="scene-title">
                <img :src="listdata.template.image" :alt="listdata.template.title">
                <p>{{listdata.template.title}}</p>
            </div>
            <div class="form" v-for="(item,index) in listdata.list" :key="index">
                <div v-if="item.type=='input'">
                    <p :class="item.title!=''?'this':''">{{item.title}}</p>
                    <el-input :maxlength="item.max" v-model="item.value" :placeholder="item.tip" show-word-limit></el-input>
                </div>
                <div v-if="item.type=='textarea'">
                    <p :class="item.title!=''?'this':''">{{item.title}}</p>
                    <el-input style="height:400px" v-model="item.value" type="textarea" :maxlength="item.max" :placeholder="item.tip" show-word-limit></el-input>
                </div>
                <div v-if="item.type=='list'">
                    <p class="this">{{item.name}}</p>
                    <ul>
                        <li :class="list==item.value?'on':''" v-for="(list,i) in item.option" :key="i">{{list}}</li>
                    </ul>
                </div>
                <div v-if="item.type=='option'">
                    <p :class="item.value!=''?'this':''">{{item.name}}</p>
                    <el-select v-model="item.value" placeholder="请选择" style="width:100%">
                        <el-option
                        v-for="list in item.option"
                        :key="list"
                        :label="list"
                        :value="list">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <p class="tip">
                <span></span>
                不知道写啥？试试插入示例
            </p>
        </el-scrollbar>
        <div class="create-button" >
            <p class="button" style="cursor: pointer;" @click="generateNow()">立即生成</p>
            <!-- <p class="msg">消耗 1 AI点（共 19 点）， 开会员免费畅享AI创作</p> -->
        </div>
    </div>
    <div class="create-content">
        <el-scrollbar>
			<div class="task">
				<p class="title">本次创作结果</p>
				<div class="taskflex" style="background: #fff;">
				    <el-input  id="textarea_id" v-model="content" rows="20" type="textarea"></el-input>
					<div v-if="video_template.id > 0" style=" position: relative;">
						<el-image style="width: 100px;height: 100px;margin-left: 20px;" :src="video_template.show_image"></el-image>
					</div>
					<el-button style="width: 100px;height: 100px;margin-bottom: 20px;margin-left: 20px;" type="primary" @click="changeTemplate">{{ video_template.id > 0 ? '更换模板' : '选择模板' }}</el-button>
					<!-- <el-button style="width: 100px;height: 100px;margin-bottom: 20px;margin-left: 20px;" type="success" @click="moreTemplate">更多模板</el-button> -->
					<div class="create-button" >
					    <p class="button" style="cursor: pointer;" @click="createVideo()">生成视频</p>
					</div>
				</div>
			</div>
           <!-- <div class="task">
                <p class="title">本次创作结果</p>
                <div class="taskflex">
                    <div class="taskbox" v-for="(item,index) in task1" :key="index">
                        <div class="taskheader">
                            <div class="taskheaderright">
                                <img :src="item.image" alt="">
                                <span>{{item.title}}</span>
                            </div>
                            <div class="taskheaderleft">
                                <span>{{item.createtime}}</span>
                                <i class="el-icon-copy-document" @click="copy($event,item.content)"></i>
                            </div>
                        </div>
                        <div class="taskcontent">
                            <div class="answer">{{item.content}}</div>
                        </div>
                    </div>
                </div>
            </div> -->
           <!-- <div class="task">
                <p class="title">创作历史</p>
                <div class="taskflex">
                    <div class="taskbox" v-for="(item,index) in task2" :key="index">
                        <div class="taskheader">
                            <div class="taskheaderright">
                                <img :src="item.image" alt="">
                                <span>{{item.title}}</span>
                            </div>
                            <div class="taskheaderleft">
                                <span>{{item.createtime}}</span>
                                <i class="el-icon-copy-document" @click="copy($event,item.content)"></i>
                                <i class="el-icon-delete"></i>
                            </div>
                        </div> 
                        <div class="taskcontent">
                            <div class="answer">{{item.content}}</div>
                        </div>
                    </div>
                </div>
            </div> -->
        </el-scrollbar>
    </div>
    <microvideobox ref="microvideobox"  @colsechatbox="colsechatbox"></microvideobox>
	<login v-if="loginbox" @closelogin="closelogin"></login>
  </div>
</template>

<script>
import {
	fetchEventSource
} from "@microsoft/fetch-event-source";
import { Message } from 'element-ui'
// import {chat } from '@/api/article';
import chatshowbox from '@/components/chatshowbox'
import login from '@/components/login'
import microvideobox from '@/components/microvideobox'
// import {fetchEventSource} from "@microsoft/fetch-event-source";
import {indexFields,articleGetHistory} from '@/api/copywriting'
import {createVideo,updateContent} from '@/api/article'
import Clipboard from 'clipboard'
import { Empty } from "element-ui";
export default {
	components: {
	    chatshowbox,
	    microvideobox,
        login
	},
    data(){
        return {    
			loading:false,
			loginbox:false,
			pageId:0,
			chatboxstatus:false,
            listdata:{
				template:{},
                list:[],
			},
			aid:0,
			video_template:{
				id:0,
				show_image:'',
			},
			content:'',
            task1:[
                
            ],
            task2:[
                
            ]
        }
    },
    mounted(){
        this.pageId = this.$route.params.id;
        indexFields({tid:this.pageId}).then(res=>{
            this.listdata = res.data
			if(res.data.template.video_template != null && res.data.template.video_template.id > 0) {
				this.video_template.id = res.data.template.video_template.id;
				this.video_template.show_image = res.data.template.video_template.show_image;
			}
        })
        // this.articleGetHistory()
    },
	methods: {
		moreTemplate() {
			if(this.aid <= 0) {
				Message({
					message: '请先生成文案内容',
					type: 'error',
					duration: 3 * 1000
				})
				return;
			}
			updateContent({aid:this.aid, content:this.content}).then(res=>{
				this.$router.push({ path: '/microvideo?aid=' + this.aid});
			})
		},
		createVideo() {
			this.content = this.content.trim();
			if(this.content == '') {
				Message({
					message: '请先生成文案内容',
					type: 'error',
					duration: 3 * 1000
				})
				return;
			}
			if(this.video_template.id <= 0) {
				Message({
					message: '请先选择视频模板',
					type: 'error',
					duration: 3 * 1000
				})
			}
			const loading1 = this.$loading({
				lock: true,
				text: '任务提交中....',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			createVideo({creation_id:this.pageId,aid:this.aid, template_id:this.video_template.id, content:this.content}).then(res=>{
				loading1.close()
				if(res.code == 0) {
					// 成功
					Message({
						message: res.message,
						type: 'success',
						duration: 3 * 1000
					})
					this.$router.push({ path: '/history/2'});
				}else {
					Message({
						message: res.message,
						type: 'error',
						duration: 3 * 1000
					})
				}
			})
		},
		changeTemplate() {
			this.$refs.microvideobox.openDialog();
		},
        copy(event,content) {
            const clipboard = new Clipboard(event.target, {
                text: () => content,
            })
            clipboard.on('success', () => {
                clipboard.destroy()
                this.$message({
                    message: '复制成功',
                    type: 'success',
                    duration: 3 * 1000
                })
            })
            clipboard.on('error', () => {
                clipboard.destroy()
                this.$message({
                    message: '复制失败',
                    type: 'error',
                    duration: 3 * 1000
                })
            })
            clipboard.onClick(event)	
        },
        closelogin(){
            this.loginbox = false
        },
		colsechatbox(id, img){
			this.video_template.id = id;
			this.video_template.show_image = img;
		},
		startContent(chat_url, params,video_template) {
			// this.video_template = video_template;
			let arr = JSON.parse(params)
			let data = {
				title : arr.template.title,
				id: arr.template.id,
				fields: arr.list
			}
			this.content = '';
			let that = this;
			let headers = {
				token:localStorage.getItem('gpt-token')
			};
			// return false;
			let eventSourcepost = fetchEventSource(chat_url, {
				method: 'POST',
				headers: headers,
				// signal: abortController,
				body: JSON.stringify(data),
				// openWhenHidden:true,
				onopen(event) {
					if (event.status != 200) {
						Message({
							message: '服务器内部错误',
							type: 'error',
							duration: 5 * 1000
						})
					} else {
						that.loading = true;
					}
				},
				onmessage(event) {
					// console.log(event)
					try {
						var content = event.data;
						if(content.indexOf('error_msg') > -1) {
							Message({
							    message: content,
							    type: 'error',
							    duration: 5 * 1000
							})
						}else {
							console.log(content);
							
							content = content.replaceAll("\\n", '\n');
							content = content.replaceAll("\\r\\n", '\n');
							console.log('替换了', content);
							//console.log(content.indexOf('lastId:') > -1);
							if(content.indexOf('lastId:') > -1) {
								that.aid = content.replace('lastId:', '').trim();
								//console.log(that.aid)
							}else {
								that.content = that.content + content;
							}
							that.rollingBottom()
						}
					} catch (error) {
						console.log(error);
						// that.ctrlAbout.abort()
					}
				},
				onerror(event) {
					// 服务异常
					console.log("onerror:", event);
					that.loading = false;
				},
				onclose(event) {
					console.log("onclose:", event);
					that.loading = false;
					if(that.video_template == null) {
						that.show_go_video = true;
					}
					that.$emit("articleGetHistory");
				}
			})
		},
		rollingBottom () {
			let textarea = document.getElementById('textarea_id');
			textarea.scrollTop = textarea.scrollHeight;
		},
		generateNow() {
            if(!localStorage.getItem('gpt-token')){
                this.loginbox = true
                return false;
            }
            try{
                this.listdata.list.forEach((item,index) => {
                    if(!item.value){
                        throw Error(item.title);
                    }
                });
            }catch(e){
                this.$message.error(e+'不能为空');
                return false;
            }
			// this.chatboxstatus = true;
			this.startContent(this.listdata.template.chat_url,JSON.stringify(this.listdata),this.listdata.template.video_template);
		},
        articleGetHistory(){
            articleGetHistory().then(res=>{
                this.task1 = res.data.result
                this.task2 = res.data.history
            })
        }
	},
}
</script>

<style lang="less">
    @media (min-width:1600px) {
        .articlebox{
            .taskbox{
                flex: 0 0 32%;
            }
        }
    }
    @media (max-width:1600px) {
        .articlebox{
            .taskbox{
                flex: 0 0 48%;
            }
        }
    }
    .articlebox{
        background: #f4f5f7;
        display: flex;
        height: calc(100vh - 60px);
        padding: 24px 24px 24px 24px;
        position: relative;
        .create-button{
            background-color: #fff;
            position: absolute;
            height: 122px;
            bottom: 0;
            left: 0;
            right: 0;
            .button{
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 13px 20px;
                width: 223px;
                height: 58px;
                background: linear-gradient(106.92deg,#10c5fe 14.83%,#1093fe 31.52%,#4f4fe7 65.11%,#b60cb9 91.29%,#e0caf5 102.83%),#2d8af5;
                box-shadow: 0 2px 8px rgba(52,70,237,.1);
                border-radius: 55px;
                cursor: pointer;
                color: #fff;
                font-size: 16px;
                font-weight: 700;
                margin:20px auto 0;
            }
            .msg{
                font-weight: 400;
                font-size: 12px;
                line-height: 16px;
                color: #999;
                margin-top: 8px;
                text-align: center;
            }
        }
        .create-box{
            .el-scrollbar{
                height: 100%;
                .el-scrollbar__wrap{
                    overflow-x: hidden;
                    padding-bottom: 122px;
                }
            }
            height: 100%;
            background: #fff;
            width: 418px;
            margin-right: 20px;
            box-sizing: border-box;
            padding: 20px ;
            position: relative;
            border-radius: 12px;
            .scene-title{
                display: flex;
                font-weight: 700;
                font-size: 16px;
                line-height: 22px;
                color: #4e5969;
                margin-bottom: 20px;
                img{
                    width: 22px;
                }
            }
            .form{
                div{
                    margin-bottom: 20px;
                }
                p{
                    color: #333;
                    font-size: 14px;
                    font-weight: 700px;
                    margin-bottom: 8px;
                }
                .this{
                    padding-left: 12px;
                    position: relative;
                }
                .this::after{
                    content:"*";
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left:0;
                    color: #ff5556;
                }
                .el-input{
                    background-color: #f4f5f7;
                    border: 1px solid #f4f5f7;
                    border-radius: 8px;
                    input{
                        border: none;
                        background:transparent;
                    }
                    .el-input__count-inner{
                        background-color: transparent;
                    }
                }
                .el-textarea{
                    background-color: #f4f5f7;
                    border: 1px solid #f4f5f7;
                    border-radius: 8px;
                    .el-textarea__inner{
                        border: none;
                        background:transparent;
                        height: 100%;
                    }
                    .el-input__count{
                        background-color: transparent;
                    }
                }
                ul{
                    display: flex;
                    flex-wrap: wrap;
                    gap: 8px;
                    li{
                        height: 36px;
                        background: #f7f7f7;
                        border-radius: 8px;
                        color: #020713;
                        border: 1px solid transparent;
                        // padding: 10px 16px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 12px;
                        padding: 0 16px;
                        cursor: pointer;
                    }
                    .on{
                        color: rgb(45, 138, 245);
                    }
                }
            }

            .tip{
                margin: 20px auto;
                width: 211px;
                height: 35px;
                color: #1d2129;
                font-weight: 400;
                font-size: 12px;
                line-height: 16px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                border-radius: 500px;
                span{
                    background: url(../../assets/ai-pc-icon-6fdc37eb.png) no-repeat;
                    display: inline-block;
                    width: 13px;
                    height: 15px;
                    background-position: -165px -20px;
                    margin-right: 8px;
                }
            }
            .tip:hover{
                background-color: #f5f7fa;
            }
        }
        .create-content{
            flex: 1 0 10%;
            height: 100%;
            .el-scrollbar{
                width: 100%;
                height: 100%;
                .el-scrollbar__wrap{
                    overflow-x: hidden;
                }
            }
            .taskflex{
                display: flex;
                flex-wrap: wrap;
                gap: 16px;
            }
            .task:nth-child(1){
                border-bottom:1px solid #ddd;
                padding-bottom: 20px;
                margin-bottom: 20px;
            }
            .task{
                .title{
                    font-weight: 700;
                    font-size: 16px;
                    line-height: 21px;
                    color: #1d2129;
                    margin-bottom: 16px;
                }
            }
            .taskbox{
                height: 220px;
                min-width: 360px;
                background: #ffffff;
                border-radius: 10px;
                box-sizing: border-box;
                padding: 20px 24px 24px;
                .taskheader{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 20px;
                    .taskheaderright{
                        display: flex;
                        align-items: center;
                        margin-right: 20px;
                        img{
                            width: 20px;
                            height: 20px;
                            margin-right: 8px;
                        }
                        span{
                            font-weight: 700;
                            font-size: 14px;
                            line-height: 22px;
                            color: #6f8792;
                        }
                    }
                    .taskheaderleft{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        // flex: 1 0 10%;
                        opacity: 0;
                        span{
                            padding-right: 8px;
                            font-weight: 400;
                            font-size: 11px;
                            line-height: 18px;
                            color: #b2b2b2;
                            white-space: nowrap;
                            border-right: 1px solid #b2b2b2;
                        }
                        i{
                            margin-left: 12px;
                            cursor: pointer;
                        }
                    }
                }
                .taskheader:hover{
                    .taskheaderleft{
                        opacity: 1;
                    }
                }
                .taskcontent{
                    .problem{
                        font-weight: 700;
                        line-height: 21px;
                        color: #333940;
                        margin: 16px 0;
                        width: 100%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .answer{
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 7;
                        overflow: hidden;
                        font-weight: 400;
                        font-size: 14px;
                        color: #6f8792;
                    }
                }
            }
        }
    }
</style>